export const AaaContactStudioFormId = "aaa-contact-studio";

export enum AaaContactStudioSubFormsId {
  ContactInformation = "contact",
  StudioInformation = "studio",
}

export const AaaContactStudioSubFormsIdsOrder = [
  AaaContactStudioSubFormsId.ContactInformation,
  AaaContactStudioSubFormsId.StudioInformation,
];

export const AaaContactStudioSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "introFormsTitle",
  ["formSubtitle"]: "",
  [AaaContactStudioSubFormsId.ContactInformation]: "introContactInformationTitle",
  [AaaContactStudioSubFormsId.StudioInformation]: "introStudioInformationTitle",
};
